export default "__VITE_ASSET__BGkD1bKV__"